export default __webpack_public_path__ + "static/media/land-rover.1961fff1.svg";